// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"164":"30e9c8da","977":"30e9c8da"}[chunkId] + ".chunk.css";
};